
export const bestSellerProducts = [
  {
    id: 1,
    name: "Floral Summer Dress",
    price: 12500,
    originalPrice: 18000,
    image: "https://readdy.ai/api/search-image?query=Beautiful%20floral%20summer%20dress%20for%20women%20on%20clean%20white%20background%20fashion%20photography%20elegant%20feminine%20style%20high%20quality%20product%20shot%20soft%20lighting%20professional%20catalog%20image&width=400&height=500&seq=1&orientation=portrait",
    badges: ["Best Seller"],
    category: "dresses",
    description: "A beautiful floral summer dress perfect for warm days. Features a flattering A-line silhouette with delicate floral prints. Made from lightweight, breathable fabric for all-day comfort."
  },
  {
    id: 2,
    name: "Elegant Blazer Set",
    price: 28500,
    originalPrice: 35000,
    image: "https://readdy.ai/api/search-image?query=Elegant%20womens%20blazer%20suit%20set%20professional%20office%20wear%20on%20clean%20white%20background%20fashion%20photography%20sophisticated%20feminine%20style%20high%20quality%20product%20shot%20soft%20lighting&width=400&height=500&seq=2&orientation=portrait",
    badges: ["Best Seller", "Low Stock"],
    category: "tops",
    description: "A sophisticated blazer set that transitions seamlessly from office to evening. Tailored fit with premium fabric that holds its shape beautifully."
  },
  {
    id: 3,
    name: "Chic Midi Skirt",
    price: 8900,
    originalPrice: 12000,
    image: "https://readdy.ai/api/search-image?query=Stylish%20midi%20skirt%20for%20women%20elegant%20A-line%20silhouette%20on%20clean%20white%20background%20fashion%20photography%20feminine%20style%20high%20quality%20product%20shot%20soft%20lighting%20professional&width=400&height=500&seq=3&orientation=portrait",
    badges: ["Best Seller"],
    category: "bottoms",
    description: "An elegant midi skirt with a flattering A-line cut. Perfect for both casual and formal occasions. Pairs beautifully with blouses and heels."
  }
];

export const allProducts = [
  {
    id: 4,
    name: "Off-Shoulder Blouse",
    price: 7500,
    originalPrice: 10000,
    image: "https://readdy.ai/api/search-image?query=Beautiful%20off%20shoulder%20blouse%20for%20women%20romantic%20feminine%20style%20on%20clean%20white%20background%20fashion%20photography%20high%20quality%20product%20shot%20soft%20lighting%20professional%20catalog&width=400&height=500&seq=4&orientation=portrait",
    badges: ["New Arrival"],
    category: "tops",
    description: "A romantic off-shoulder blouse that adds a touch of elegance to any outfit. Soft, flowing fabric with delicate details."
  },
  {
    id: 5,
    name: "High-Waist Jeans",
    price: 15000,
    originalPrice: 18500,
    image: "https://readdy.ai/api/search-image?query=Stylish%20high%20waist%20jeans%20for%20women%20slim%20fit%20denim%20on%20clean%20white%20background%20fashion%20photography%20casual%20feminine%20style%20high%20quality%20product%20shot%20soft%20lighting&width=400&height=500&seq=5&orientation=portrait",
    badges: [],
    category: "bottoms",
    description: "Classic high-waist jeans with a flattering slim fit. Premium stretch denim for comfort and style. A wardrobe essential."
  },
  {
    id: 6,
    name: "Satin Wrap Dress",
    price: 18500,
    originalPrice: 24000,
    image: "https://readdy.ai/api/search-image?query=Elegant%20satin%20wrap%20dress%20for%20women%20luxurious%20evening%20wear%20on%20clean%20white%20background%20fashion%20photography%20sophisticated%20feminine%20style%20high%20quality%20product%20shot&width=400&height=500&seq=6&orientation=portrait",
    badges: ["Hot"],
    category: "dresses",
    description: "A luxurious satin wrap dress perfect for special occasions. The wrap design flatters every figure while the satin fabric adds elegance."
  },
  {
    id: 7,
    name: "Casual Jumpsuit",
    price: 16800,
    originalPrice: 22000,
    image: "https://readdy.ai/api/search-image?query=Trendy%20casual%20jumpsuit%20for%20women%20comfortable%20stylish%20one%20piece%20on%20clean%20white%20background%20fashion%20photography%20modern%20feminine%20style%20high%20quality%20product%20shot&width=400&height=500&seq=7&orientation=portrait",
    badges: [],
    category: "jumpsuits",
    description: "A trendy casual jumpsuit that combines comfort with style. Easy to wear one-piece that looks effortlessly chic."
  },
  {
    id: 8,
    name: "Knit Cardigan",
    price: 11500,
    originalPrice: 15000,
    image: "https://readdy.ai/api/search-image?query=Cozy%20knit%20cardigan%20sweater%20for%20women%20soft%20comfortable%20layering%20piece%20on%20clean%20white%20background%20fashion%20photography%20feminine%20style%20high%20quality%20product%20shot&width=400&height=500&seq=8&orientation=portrait",
    badges: [],
    category: "tops",
    description: "A cozy knit cardigan perfect for layering. Soft, comfortable fabric that keeps you warm while looking stylish."
  },
  {
    id: 9,
    name: "Pleated Maxi Skirt",
    price: 13500,
    originalPrice: 17000,
    image: "https://readdy.ai/api/search-image?query=Elegant%20pleated%20maxi%20skirt%20for%20women%20flowing%20feminine%20silhouette%20on%20clean%20white%20background%20fashion%20photography%20graceful%20style%20high%20quality%20product%20shot&width=400&height=500&seq=9&orientation=portrait",
    badges: ["Best Seller"],
    category: "bottoms",
    description: "An elegant pleated maxi skirt with beautiful movement. The flowing silhouette creates a graceful, feminine look."
  },
  {
    id: 10,
    name: "Lace Cami Top",
    price: 6500,
    originalPrice: 8500,
    image: "https://readdy.ai/api/search-image?query=Delicate%20lace%20camisole%20top%20for%20women%20romantic%20feminine%20lingerie%20style%20on%20clean%20white%20background%20fashion%20photography%20elegant%20high%20quality%20product%20shot&width=400&height=500&seq=10&orientation=portrait",
    badges: [],
    category: "tops",
    description: "A delicate lace camisole top with romantic details. Perfect for layering or wearing on its own for a feminine look."
  },
  {
    id: 11,
    name: "Tailored Trousers",
    price: 14500,
    originalPrice: 19000,
    image: "https://readdy.ai/api/search-image?query=Elegant%20tailored%20trousers%20for%20women%20professional%20office%20pants%20on%20clean%20white%20background%20fashion%20photography%20sophisticated%20feminine%20style%20high%20quality%20product%20shot&width=400&height=500&seq=11&orientation=portrait",
    badges: [],
    category: "bottoms",
    description: "Elegant tailored trousers with a professional fit. Perfect for the office or dressed up for evening events."
  },
  {
    id: 12,
    name: "Ruffle Mini Dress",
    price: 11000,
    originalPrice: 14500,
    image: "https://readdy.ai/api/search-image?query=Cute%20ruffle%20mini%20dress%20for%20women%20playful%20feminine%20style%20on%20clean%20white%20background%20fashion%20photography%20youthful%20elegant%20high%20quality%20product%20shot&width=400&height=500&seq=12&orientation=portrait",
    badges: ["New Arrival"],
    category: "dresses",
    description: "A cute ruffle mini dress with playful details. Perfect for dates, parties, or any occasion where you want to stand out."
  },
  {
    id: 13,
    name: "Silk Scarf",
    price: 4500,
    originalPrice: 6000,
    image: "https://readdy.ai/api/search-image?query=Luxurious%20silk%20scarf%20accessory%20for%20women%20elegant%20pattern%20design%20on%20clean%20white%20background%20fashion%20photography%20sophisticated%20feminine%20style%20high%20quality%20product%20shot&width=400&height=500&seq=13&orientation=portrait",
    badges: [],
    category: "accessories",
    description: "A luxurious silk scarf with an elegant pattern. Versatile accessory that can be worn multiple ways to elevate any outfit."
  },
  {
    id: 14,
    name: "Bodycon Dress",
    price: 9800,
    originalPrice: 13000,
    image: "https://readdy.ai/api/search-image?query=Sleek%20bodycon%20dress%20for%20women%20figure%20hugging%20evening%20wear%20on%20clean%20white%20background%20fashion%20photography%20sexy%20feminine%20style%20high%20quality%20product%20shot&width=400&height=500&seq=14&orientation=portrait",
    badges: ["Hot"],
    category: "dresses",
    description: "A sleek bodycon dress that hugs your curves beautifully. Perfect for nights out or special occasions."
  },
  {
    id: 15,
    name: "Cropped Denim Jacket",
    price: 17500,
    originalPrice: 22000,
    image: "https://readdy.ai/api/search-image?query=Stylish%20cropped%20denim%20jacket%20for%20women%20casual%20trendy%20outerwear%20on%20clean%20white%20background%20fashion%20photography%20modern%20feminine%20style%20high%20quality%20product%20shot&width=400&height=500&seq=15&orientation=portrait",
    badges: [],
    category: "tops",
    description: "A stylish cropped denim jacket that adds edge to any outfit. Classic design with modern details."
  },
  {
    id: 16,
    name: "Flowy Palazzo Pants",
    price: 12000,
    originalPrice: 15500,
    image: "https://readdy.ai/api/search-image?query=Elegant%20flowy%20palazzo%20pants%20for%20women%20wide%20leg%20comfortable%20style%20on%20clean%20white%20background%20fashion%20photography%20graceful%20feminine%20high%20quality%20product%20shot&width=400&height=500&seq=16&orientation=portrait",
    badges: [],
    category: "bottoms",
    description: "Elegant flowy palazzo pants with a wide leg design. Comfortable yet sophisticated for any occasion."
  },
  {
    id: 17,
    name: "Statement Earrings",
    price: 3500,
    originalPrice: 5000,
    image: "https://readdy.ai/api/search-image?query=Beautiful%20statement%20earrings%20jewelry%20for%20women%20elegant%20gold%20design%20on%20clean%20white%20background%20fashion%20photography%20sophisticated%20feminine%20accessory%20high%20quality%20product%20shot&width=400&height=500&seq=17&orientation=portrait",
    badges: [],
    category: "accessories",
    description: "Beautiful statement earrings that add glamour to any look. Elegant gold design that catches the light beautifully."
  },
  {
    id: 18,
    name: "Puff Sleeve Top",
    price: 8500,
    originalPrice: 11000,
    image: "https://readdy.ai/api/search-image?query=Trendy%20puff%20sleeve%20blouse%20top%20for%20women%20romantic%20feminine%20style%20on%20clean%20white%20background%20fashion%20photography%20elegant%20high%20quality%20product%20shot%20soft%20lighting&width=400&height=500&seq=18&orientation=portrait",
    badges: ["New Arrival"],
    category: "tops",
    description: "A trendy puff sleeve top with romantic details. The statement sleeves add drama to this feminine piece."
  },
  {
    id: 19,
    name: "Elegant Evening Jumpsuit",
    price: 24500,
    originalPrice: 32000,
    image: "https://readdy.ai/api/search-image?query=Elegant%20evening%20jumpsuit%20for%20women%20sophisticated%20formal%20one%20piece%20on%20clean%20white%20background%20fashion%20photography%20glamorous%20feminine%20style%20high%20quality%20product%20shot&width=400&height=500&seq=25&orientation=portrait",
    badges: ["New Arrival"],
    category: "jumpsuits",
    description: "An elegant evening jumpsuit perfect for formal occasions. Sophisticated design with flattering silhouette."
  },
  {
    id: 20,
    name: "Gold Chain Necklace",
    price: 5500,
    originalPrice: 7500,
    image: "https://readdy.ai/api/search-image?query=Elegant%20gold%20chain%20necklace%20jewelry%20for%20women%20delicate%20layering%20piece%20on%20clean%20white%20background%20fashion%20photography%20sophisticated%20feminine%20accessory%20high%20quality%20product%20shot&width=400&height=500&seq=26&orientation=portrait",
    badges: [],
    category: "accessories",
    description: "A delicate gold chain necklace perfect for layering or wearing alone. Timeless elegance for everyday wear."
  },
  {
    id: 21,
    name: "Wide Leg Jumpsuit",
    price: 19500,
    originalPrice: 25000,
    image: "https://readdy.ai/api/search-image?query=Stylish%20wide%20leg%20jumpsuit%20for%20women%20modern%20chic%20one%20piece%20on%20clean%20white%20background%20fashion%20photography%20elegant%20feminine%20style%20high%20quality%20product%20shot&width=400&height=500&seq=27&orientation=portrait",
    badges: ["Hot"],
    category: "jumpsuits",
    description: "A stylish wide leg jumpsuit with modern appeal. Comfortable and chic for any occasion."
  },
  {
    id: 22,
    name: "Designer Handbag",
    price: 28000,
    originalPrice: 35000,
    image: "https://readdy.ai/api/search-image?query=Elegant%20designer%20handbag%20for%20women%20luxury%20leather%20purse%20on%20clean%20white%20background%20fashion%20photography%20sophisticated%20feminine%20accessory%20high%20quality%20product%20shot&width=400&height=500&seq=28&orientation=portrait",
    badges: ["Best Seller"],
    category: "accessories",
    description: "A luxurious designer handbag crafted from premium leather. Spacious interior with elegant hardware details."
  }
];

export const bannerSlides = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=Fashion%20banner%20elegant%20women%20clothing%20collection%20summer%20sale%20promotional%20image%20stylish%20feminine%20aesthetic%20soft%20pink%20tones%20professional%20fashion%20photography%20models%20wearing%20trendy%20outfits&width=900&height=300&seq=19&orientation=landscape"
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=Fashion%20banner%20new%20arrivals%20women%20dresses%20collection%20promotional%20image%20elegant%20feminine%20aesthetic%20soft%20pastel%20colors%20professional%20fashion%20photography%20stylish%20modern%20look&width=900&height=300&seq=20&orientation=landscape"
  }
];

export const categories = [
  {
    id: 1,
    name: "Dresses",
    slug: "dresses",
    image: "https://readdy.ai/api/search-image?query=Elegant%20womens%20dress%20collection%20fashion%20category%20image%20beautiful%20feminine%20style%20on%20soft%20pink%20background%20professional%20fashion%20photography%20high%20quality&width=300&height=300&seq=21&orientation=squarish"
  },
  {
    id: 2,
    name: "Tops",
    slug: "tops",
    image: "https://readdy.ai/api/search-image?query=Stylish%20womens%20tops%20blouses%20collection%20fashion%20category%20image%20feminine%20style%20on%20soft%20pink%20background%20professional%20fashion%20photography%20high%20quality&width=300&height=300&seq=22&orientation=squarish"
  },
  {
    id: 3,
    name: "Bottoms",
    slug: "bottoms",
    image: "https://readdy.ai/api/search-image?query=Trendy%20womens%20skirts%20pants%20collection%20fashion%20category%20image%20feminine%20style%20on%20soft%20pink%20background%20professional%20fashion%20photography%20high%20quality&width=300&height=300&seq=23&orientation=squarish"
  },
  {
    id: 4,
    name: "Jumpsuits",
    slug: "jumpsuits",
    image: "https://readdy.ai/api/search-image?query=Stylish%20womens%20jumpsuits%20rompers%20collection%20fashion%20category%20image%20elegant%20feminine%20style%20on%20soft%20pink%20background%20professional%20fashion%20photography%20high%20quality&width=300&height=300&seq=29&orientation=squarish"
  },
  {
    id: 5,
    name: "Accessories",
    slug: "accessories",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20womens%20fashion%20accessories%20jewelry%20bags%20collection%20category%20image%20elegant%20feminine%20style%20on%20soft%20pink%20background%20professional%20photography&width=300&height=300&seq=24&orientation=squarish"
  }
];

export const bestSellers = [
  {
    id: 1,
    name: 'Floral Summer Dress',
    price: 12500,
    originalPrice: 18000,
    discount: 31,
    image: 'http://prudent.dealdrivetechnology.com/static/media/floral-dress.jpg',
    badges: ['Best Seller']
  },
  {
    id: 2,
    name: 'Elegant Blazer Set',
    price: 28500,
    originalPrice: 35000,
    discount: 19,
    image: 'http://prudent.dealdrivetechnology.com/static/media/blazer-set.jpg',
    badges: ['Best Seller', 'Low Stock']
  },
  {
    id: 3,
    name: 'Chic Midi Skirt',
    price: 8900,
    originalPrice: 12000,
    discount: 26,
    image: 'http://prudent.dealdrivetechnology.com/static/media/midi-skirt.jpg',
    badges: ['Best Seller']
  }
];

export const newArrivals = [
  {
    id: 4,
    name: 'Off-Shoulder Blouse',
    price: 7500,
    originalPrice: 10000,
    discount: 25,
    image: 'http://prudent.dealdrivetechnology.com/static/media/off-shoulder.jpg',
    badges: ['New Arrival']
  },
  {
    id: 5,
    name: 'High-Waist Jeans',
    price: 15000,
    originalPrice: 18500,
    discount: 19,
    image: 'http://prudent.dealdrivetechnology.com/static/media/jeans.jpg',
    badges: []
  },
  {
    id: 6,
    name: 'Satin Wrap Dress',
    price: 18500,
    originalPrice: 24000,
    discount: 23,
    image: 'http://prudent.dealdrivetechnology.com/static/media/wrap-dress.jpg',
    badges: ['Hot']
  },
  {
    id: 7,
    name: 'Casual Jumpsuit',
    price: 16800,
    originalPrice: 22000,
    discount: 24,
    image: 'http://prudent.dealdrivetechnology.com/static/media/jumpsuit.jpg',
    badges: []
  },
  {
    id: 8,
    name: 'Knit Cardigan',
    price: 11500,
    originalPrice: 15000,
    discount: 23,
    image: 'http://prudent.dealdrivetechnology.com/static/media/cardigan.jpg',
    badges: []
  },
  {
    id: 9,
    name: 'Pleated Maxi Skirt',
    price: 13500,
    originalPrice: 17000,
    discount: 21,
    image: 'http://prudent.dealdrivetechnology.com/static/media/maxi-skirt.jpg',
    badges: ['Best Seller']
  },
  {
    id: 10,
    name: 'Lace Cami Top',
    price: 6500,
    originalPrice: 8500,
    discount: 24,
    image: 'http://prudent.dealdrivetechnology.com/static/media/cami-top.jpg',
    badges: []
  },
  {
    id: 11,
    name: 'Tailored Trousers',
    price: 14500,
    originalPrice: 19000,
    discount: 24,
    image: 'http://prudent.dealdrivetechnology.com/static/media/trousers.jpg',
    badges: []
  },
  {
    id: 12,
    name: 'Ruffle Mini Dress',
    price: 11000,
    originalPrice: 14500,
    discount: 24,
    image: 'http://prudent.dealdrivetechnology.com/static/media/ruffle-dress.jpg',
    badges: ['New Arrival']
  },
  {
    id: 13,
    name: 'Silk Scarf',
    price: 4500,
    originalPrice: 6000,
    discount: 25,
    image: 'http://prudent.dealdrivetechnology.com/static/media/scarf.jpg',
    badges: []
  },
  {
    id: 14,
    name: 'Bodycon Dress',
    price: 9800,
    originalPrice: 13000,
    discount: 25,
    image: 'http://prudent.dealdrivetechnology.com/static/media/bodycon.jpg',
    badges: ['Hot']
  },
  {
    id: 15,
    name: 'Cropped Denim Jacket',
    price: 17500,
    originalPrice: 22000,
    discount: 20,
    image: 'http://prudent.dealdrivetechnology.com/static/media/denim-jacket.jpg',
    badges: []
  },
  {
    id: 16,
    name: 'Flowy Palazzo Pants',
    price: 12000,
    originalPrice: 15500,
    discount: 23,
    image: 'http://prudent.dealdrivetechnology.com/static/media/palazzo.jpg',
    badges: []
  },
  {
    id: 17,
    name: 'Statement Earrings',
    price: 3500,
    originalPrice: 5000,
    discount: 30,
    image: 'http://prudent.dealdrivetechnology.com/static/media/earrings.jpg',
    badges: []
  },
  {
    id: 18,
    name: 'Puff Sleeve Top',
    price: 8500,
    originalPrice: 11000,
    discount: 23,
    image: 'http://prudent.dealdrivetechnology.com/static/media/puff-sleeve.jpg',
    badges: ['New Arrival']
  },
  {
    id: 19,
    name: 'Elegant Evening Jumpsuit',
    price: 24500,
    originalPrice: 32000,
    discount: 23,
    image: 'http://prudent.dealdrivetechnology.com/static/media/evening-jumpsuit.jpg',
    badges: ['New Arrival']
  },
  {
    id: 20,
    name: 'Gold Chain Necklace',
    price: 5500,
    originalPrice: 7500,
    discount: 27,
    image: 'http://prudent.dealdrivetechnology.com/static/media/necklace.jpg',
    badges: []
  }
];


